// extracted by mini-css-extract-plugin
export default {"backDrop":"Modal_backDrop__WFlO+","overlay":"Modal_overlay__r63M6"};